import i18n from '@/i18n';

const configFormContact = () => {
    return {
        configFieldTitleBlockContact: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('landingPage.settingContact.titleBlock'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['required', 'max255']
        },
        configFieldSizeTitle: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('landingPage.setSizeText'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['max255']
        },
        configFieldContactOfficeName: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('landingPage.settingContact.contactOfficeName'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['max255']
        },
        configFieldTel: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('landingPage.settingContact.tel'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['max20', 'number-hyphens']
        },
        configFieldMail: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('landingPage.settingContact.mail'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['max255', 'email']
        }
    };
};

export { configFormContact };
